<template>
  <div class="swiper-card card-app">
    <div class="corner-radius-blur"></div>
    <div class="icon" :key="'icon'">
      <svg width="169" height="150" viewBox="0 0 169 150" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M114.594 0.0878915C124.072 1.05469 131.467 9.05273 131.467 18.75V131.25C131.467 140.947 124.072 148.945 114.594 149.912L112.686 150H56.3431L54.4357 149.912C44.9571 148.945 37.5621 140.947 37.5621 131.25V18.75C37.5621 9.05273 44.9571 1.05469 54.4357 0.0878915L56.3431 0H112.686L114.594 0.0878915ZM56.3431 14.0625C53.7607 14.0625 51.6479 16.1719 51.6479 18.75V131.25C51.6479 133.828 53.7607 135.938 56.3431 135.938H112.686C115.269 135.938 117.381 133.828 117.381 131.25V18.75C117.381 16.1719 115.269 14.0625 112.686 14.0625H56.3431ZM96.2528 107.812C100.156 107.812 103.296 110.947 103.296 114.844C103.296 118.74 100.156 121.875 96.2528 121.875H72.7765C68.8736 121.875 65.7336 118.74 65.7336 114.844C65.7336 110.947 68.8736 107.812 72.7765 107.812H96.2528ZM14.3205 39.082C17.079 36.8262 21.158 37.002 23.7404 39.5801C26.4989 42.334 26.4989 46.7871 23.7404 49.5117L14.6433 58.5938L22.0971 66.0352L22.9481 66.9727C24.7968 69.2285 25.8239 72.0703 25.8239 75C25.8239 78.3691 24.474 81.5918 22.0971 83.9648L14.6433 91.4062L23.7404 100.488L24.2393 101.016C26.4989 103.77 26.3228 107.842 23.7404 110.42C21.158 112.998 17.079 113.145 14.3205 110.918L13.7923 110.449L3.72686 100.371C1.64334 98.291 0.352145 95.5664 0.058691 92.666L0 91.4062L0.058691 90.1465C0.352145 87.2461 1.64334 84.5215 3.72686 82.4414L11.1806 75L3.72686 67.5586C1.64334 65.4785 0.352145 62.7539 0.058691 59.8535L0 58.5938L0.058691 57.334C0.352145 54.4336 1.64334 51.709 3.72686 49.6289L13.7923 39.5508L14.3205 39.082ZM145.26 39.5508C147.842 36.9727 151.921 36.8262 154.679 39.0527L155.208 39.5508L165.273 49.5996C167.357 51.6797 168.648 54.4043 168.941 57.3047L169 58.5645L168.941 59.8242C168.648 62.7246 167.357 65.4492 165.273 67.5293L157.819 74.9707L165.273 82.4121C167.357 84.4922 168.648 87.2168 168.941 90.1172L169 91.377L168.941 92.6367C168.648 95.5371 167.357 98.2617 165.273 100.342L155.208 110.391L154.679 110.889C151.921 113.145 147.842 112.969 145.26 110.391C142.677 107.812 142.53 103.74 144.761 100.986L145.26 100.459L154.357 91.377L146.903 83.9355C144.526 81.5625 143.176 78.3398 143.176 74.9707C143.176 72.041 144.203 69.1992 146.052 66.9434L146.903 66.0059L154.357 58.5645L145.26 49.4824C142.501 46.7285 142.501 42.2754 145.26 39.5508Z" fill="black"/>
      </svg>
    </div>

    <h3>{{ slide.title }}</h3>
    <p>{{ slide.paragraph }}</p>

    <div class="qr-inner" :class="[`mq-${$mq}`]"> 
      <div class="qr-container">
        <div class="qr-code">
          <NourishQR />
        </div>

        <!-- <div class="button-container">
          <div @click="fireCta('apple')" class="button-element">
            <img class="button-svg" src="@/assets/images/badge-apple.svg"/>
          </div>
          <div @click="fireCta('android')" class="button-element">
            <img class="button-svg" src="@/assets/images/badge-google.svg"/>
          </div>
        </div> -->
      </div>
    </div>

    <div class="stores">
      <div class="store" @click="goAppStore('ios')">
        <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9036 0C12.0316 1.18299 11.5705 2.34874 10.8968 3.20561C10.1938 4.04914 9.06914 4.69434 7.97368 4.61124C7.8303 3.47293 8.38532 2.2625 9.00663 1.52401C9.70895 0.685963 10.9284 0.0439017 11.9036 0ZM15.4895 6.82427C15.3673 6.89846 13.3414 8.12815 13.3636 10.636C13.3898 13.6636 15.9691 14.6655 16 14.6765C15.9845 14.747 15.5961 16.1221 14.6286 17.5168C13.8207 18.7452 12.9744 19.947 11.6299 19.9682C10.9908 19.9832 10.5593 19.7964 10.1096 19.6019C9.64047 19.3989 9.15166 19.1874 8.38699 19.1874C7.57656 19.1874 7.06613 19.4057 6.57393 19.6163C6.14806 19.7984 5.73585 19.9748 5.15478 19.9988C3.87445 20.0466 2.89616 18.688 2.05907 17.4697C0.385473 14.9838 -0.917216 10.4643 0.829487 7.38881C1.67596 5.88047 3.21915 4.90915 4.86879 4.88328C5.59522 4.86817 6.29194 5.15288 6.90271 5.40247C7.36978 5.59334 7.78659 5.76366 8.12798 5.76366C8.42784 5.76366 8.83294 5.60015 9.3051 5.40956C10.0492 5.10922 10.9598 4.74166 11.8875 4.84094C12.5219 4.85976 14.3272 5.09573 15.4919 6.82279L15.4895 6.82427Z" fill="#9A9AA3"/>
        </svg>
        <div class="content">
          <span>&ldquo;Nourish News&rdquo; on</span>
          <h4>Apple AppStore</h4>
        </div>
      </div>

      <div class="store" @click="goAppStore('android')">
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.308642 0.253662C0.0771605 0.485144 0 0.870946 0 1.33391V18.3864C0 18.8493 0.154321 19.2351 0.385802 19.4666L0.462963 19.5438L10.0309 9.97588V9.82156L0.308642 0.253662Z" fill="#9A9AA3"/>
          <path opacity="0.8" d="M13.1177 13.2166L9.9541 10.053V9.82154L13.1177 6.65796L13.1948 6.73512L16.9757 8.89561C18.056 9.5129 18.056 10.516 16.9757 11.1333L13.1177 13.2166Z" fill="#9A9AA3"/>
          <path opacity="0.5" d="M13.1944 13.1394L9.95366 9.89868L0.308594 19.5437C0.694396 19.9295 1.23452 19.9295 1.92896 19.6209L13.1944 13.1394Z" fill="#9A9AA3"/>
          <path opacity="0.5" d="M13.1944 6.65797L1.92896 0.253646C1.23452 -0.132156 0.694396 -0.0549959 0.308594 0.330807L9.95366 9.89871L13.1944 6.65797Z" fill="#9A9AA3"/>
        </svg>
        <div class="content">
          <span>&ldquo;Nourish News&rdquo; on</span>
          <h4>Google PlayStore</h4>
        </div>
      </div>
    </div>

    <button class="ghost" @click="next()">Not right now</button>
  </div>
</template>

<script>
  import NourishQR from '@/components/v5/elements/NourishQR.vue';

  export default {
    props: {
      meta: {
        type: Object,
      },
      slide: {
        type: Object,
      },
    },

    components: {
      NourishQR,
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.$emit('swiperUpdate');
          this.$emit('enableNextAction');
        }
      }, { immediate: true });
    },

    methods: {
      // fireCta(platform) {
      //   if (platform === 'apple') {
      //     window.open('https://nourished.news/ios', '_blank').focus();
      //   } else if (platform === 'android') {
      //     window.open('https://nourished.news/android', '_blank').focus();
      //   }
      // },

      goAppStore(type) {
        if (type === 'ios') {
          window.open('https://nourished.news/ios', '_blank');
        }

        if (type === 'android') {
          window.open('https://nourished.news/android', '_blank');
        }
      },


      next() {
        this.$emit('next');
      }
    },

    // watch: {
    //   '$route.params.stack': {
    //     handler(slug) {
    //       if (slug === this.slide.slug) {
    //         this.EventBus.$emit('tab:hide-next', true)
    //       } else {
    //         this.EventBus.$emit('tab:hide-next', false)
    //       }
    //     },
    //     immediate: true,
    //   },
    // }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  .card-app {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 550px;
    margin: 0 auto;
    text-align: left;
    // padding-top: 2rem;

    .ghost {
      margin: 2rem auto 0 auto;
    }

    .icon {
      margin-bottom: 2rem;

      svg {
        height: 50px;
        width: 50px;

        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }
      }
    }
  }

  h3 {
    font-family: 'Brawler';
    font-size: 50px;
    line-height: 100%;
    font-weight: normal;
    text-wrap: balance;
    margin-bottom: 1.8rem;

    .callout {
      color: $yellow-tone-4;

      .darkmode & {
        color: $yellow-tone-3;
      }
    }

    .desktop & {
      font-size: 70px;
    }
  }

  p {
    font-size: 20px;
    line-height: 150%;
    text-wrap: balance;
  }

  button {
    margin-top: 2rem;
    height: 55px;
    border-radius: 10px;
    font-size: 1rem;
    padding-top: 0.8rem;
  }

  .qr-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    margin: 2rem auto 1rem auto;

    &.mq-sm {
      display: none;
    }

    .qr-container {
      display: flex;
      margin: auto;

      .qr-code {
        svg {
          width: 10rem;
          height: 10rem;
        }
      }
    }

    .button-container {
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 1rem;
      margin: auto;
      padding: 1rem;
      margin-top: 2rem;
      width: 100%;

      .button-element {
        cursor: pointer;

        .button-svg {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
    }
  }

  .stores {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    width: 100%;
    margin-top: 1.5rem;

    .store {
      display: flex;
      flex: 1;
      align-items: center;
      padding: 0.75rem 1rem;
      border: 1px solid $neutral-400;
      color: $neutral-400;
      font-size: 0.8rem;
      border-radius: 10px;
      width: 100%;
      cursor: pointer;
      transition: background 0.3s ease-in-out;

      &:hover {
        background: rgba($neutral-400, 0.1);
      }

      svg path {
        fill: $neutral-400;
      }

      .content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        margin-left: 1rem;
        padding: 0;

        span, h4 {
          white-space: nowrap;
        }

        h4 {
          margin-top: 0;
          font-size: 0.8rem;
        }
      }
    }
  }
</style>